module.exports = __webpack_public_path__ + "static/media/icon-question-grey.81c56387.svg";